module.exports = __webpack_public_path__ + "static/media/Article 5.dfdc77b7.svg";